import {
  Breadcrumb,
  Typography,
  Button,
  Row,
  Col,
  Modal,
  Input,
  Form,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import lang from "src/lang";
import ClientNotesTable from "./ClientNoteTable";
import TinyMCEEditor from "src/common/base/Editor";

const { Title, Text } = Typography;

const ClientNote: React.FC = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleAddNoteClick = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("New Note:", values);
        // You can push to table state here if you store data in context or local state
        message.success(lang.get("clients", ["Note added successfully"]));
        setIsModalVisible(false);
        form.resetFields();
      })
      .catch(() => {});
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("clients", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("clients", ["Predifined Notes"])}</Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("clients", ["Client Notes"])}</Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("clients", ["Client Notes"])}
      </Title>

      {/* Action Button */}
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddNoteClick}
          >
            {lang.get("clients", ["New Note"])}
          </Button>
        </Col>
      </Row>

      <ClientNotesTable />

      {/* Add Note Modal */}
      <Modal
        title={lang.get("clients", ["Add New Note"])}
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={lang.get("clients", ["Save"])}
        cancelText={lang.get("clients", ["Cancel"])}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="note_header"
            label={
              <Text style={{ fontSize: 14 }}>
                {lang.get("clients", ["Note Header"])}
              </Text>
            }
            rules={[{ required: true, message: lang.get("clients", ["Please enter the note header"]) }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="description"
            label={
              <Text style={{ fontSize: 14 }}>
                {lang.get("clients", ["Description"])}
              </Text>
            }
            rules={[{ required: true, message: lang.get("clients", ["Please enter the description"]) }]}
          >
          <TinyMCEEditor />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ClientNote;
